import parse from "html-react-parser";
import React, { useState } from "react";
import PropTypes from "prop-types";
import Chatbot from "../Chatbot/Chatbot";

import { contactSupport } from "../../assets/images/icons";
import {
  ingestData,
  isMobile,
  navigateToURL,
} from "../../bridges/BridgeServices";
import "./globalChatBot.scss";

import { close } from "../../assets/images/icons";
import {
  EVENTS,
  CHATBOT_CONTEXT,
} from "../../utils/constants";
import { openBot } from "../Chatbot/ChatbotUtil";

const GlobalChatBot = ({
  supportBtnClassName,
  faqTitle,
}) => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );

  return (
    <>
      <div
        className="support-close-icon hide"
        onClick={() => {
          setOpenChatbot(false);
          document
            .getElementById("mobile-chat-container")
            .click();

          if (document) {
            document.getElementsByClassName(
              "support-close-icon"
            )[0].style.display = "none";
            document
              .getElementsByClassName(
                "support-close-icon"
              )[0]
              .classList.add("hide");
          }
        }}
      >
        {parse(close)}
      </div>
      <button
        className={`support-button ${
          supportBtnClassName ?? ""
        }`}
        style={{ display: "flex" }}
        onClick={() => {
          ingestData({
            name: EVENTS.CHATBOT_CLICKED,
            data: {
              context: CHATBOT_CONTEXT.GLOBAL,
              faqTitle,
            },
          });
          if (isMobile()) {
            navigateToURL("CHATBOT");
          } else {
            setOpenChatbot(true);
            openBot();
            setTimeout(() => {
              setOpenChatbot(false);
            }, 1000);
          }
        }}
      >
        {isMobile() && (
          <div className="support-button-icon">
            {parse(contactSupport)}
          </div>
        )}
        <div
          className={`${
            isMobile() ? "support-button-content" : ""
          }`}
        >
          <p
            className={`${
              isMobile()
                ? ""
                : "desktop-contact-support-btn contact-support-btn"
            }`}
          >
            RAISE TICKET
          </p>
        </div>
      </button>
      <Chatbot shouldOpenChatbot={shouldOpenChatbot} />
    </>
  );
};

export default GlobalChatBot;

GlobalChatBot.propTypes = {
  supportBtnClassName: PropTypes.string,
  faqTitle: PropTypes.string,
};
